import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

interface Props {
  acceptAssignment: boolean;
  onChange: (value: boolean) => void;
  claimStatus: string;
}

const AcceptingAssignment: React.FC<Props> = ({
  acceptAssignment,
  onChange,
  claimStatus,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "20px",
        height: "250px",
      }}
    >
      <Typography
        sx={{
          color: "#707070",
          fontWeight: 700,
          fontSize: "14px",
          lineHeight: "26px",
        }}
      >
        Accepting the Assignment
      </Typography>
      <p
        style={{
          color: "#707070",
          fontSize: "12px",
          lineHeight: "16px",
          marginBlockStart: "0px",
          marginBlockEnd: "0px",
          marginBottom: "15px",
          marginTop: "5px",
          fontWeight: 400,
        }}
      >
        By accepting the assignment, you as the provider agree to accept the
        payer’s approved amount as full payment for services rendered. You agree
        not to bill the patient for amounts beyond the allowed charges (except
        for copayments, coinsurance or deductibles).
      </p>

      <FormControl>
        <FormLabel
          style={{
            color: "#A29D9B",
            fontSize: "12px",
            lineHeight: "18px",
            fontWeight: 700,
            marginBottom: "10px",
          }}
        >
          Accept Assignment?
        </FormLabel>
        <RadioGroup
          row
          value={acceptAssignment ? "yes" : "no"}
          onChange={(e) => onChange(e.target.value === "yes")}
          sx={{ display: "flex", columnGap: "10px" }}
        >
          <FormControlLabel
            value="yes"
            disabled={
              claimStatus === "submitted" ||
              claimStatus === "pending_submission"
            }
            control={
              <Radio
                sx={{
                  p: 0,
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                    marginRight: "5px",
                  },
                }}
              />
            }
            label="Yes"
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "12px",
                color: "#1E1E1E",
              },
              marginLeft: "0px",
            }}
          />
          <FormControlLabel
            value="no"
            disabled={
              claimStatus === "submitted" ||
              claimStatus === "pending_submission"
            }
            control={
              <Radio
                sx={{
                  p: 0,
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                    marginRight: "5px",
                  },
                }}
              />
            }
            label="No"
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "12px",
                color: "#1E1E1E",
              },
            }}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default AcceptingAssignment;
